import React, { useContext, useRef, useState } from "react"
import GlobalErrorContext from "./GlobalErrorContext"

// import useLog from "../hooks/useLog"
import { retryevery_ms, test_runnotresponding, tryduring_ms } from "./UserContext/UserContext"
import { getLog } from "../helpers/helpers"
import { RunInventory } from "./RunInventory"
import NoFetchBlockchain, { isNoFetchBlockchain } from "../shared/NoFetchBlockchain"
import CustomStateClient from "../shared/CustomStateClient"
import OraclesUtils from "../RunCraft/OraclesUtils.js"
// import TokkenrStateClient from "../shared/TokkenrStateClient"


const Run = require("runlib")  // load RUN through webpack externals

const RunContext = React.createContext(null)

// cf report_02112022_invalidtx.md
export let banned_txhs = [
    "045088281a5a5e51dbf85fe8f7b06f48b30c994364c7e9ecb186fd0b94f6194a",
    "226101ecb92912966cc61d0e8407d71c42182326caa11a44c55e28687065a734",
    "73d41f26819b81885887ed5a69a67df181e3f08d11ac5662c1b27d6f52c3a8e0",
    "9ba5bc52bda7dc8b6d58bb21cbeb355bf2f4a2fc1b5ea14aa3a8d0227df52e15",
]
export const non_existing_txhs = [
    "e6aa4b9f7d54f7e2342cfc2f02ef86b2f48f406629b6edc9406814dbdd930465",
]
banned_txhs = banned_txhs.concat(non_existing_txhs)  // we also ban non-existing txhs


export const RunContextProvider = (props) => {

    const function_id = "RunContext: "
    const classname = function_id
    // const log = useLog(function_id)

    const globalErrorContext = useContext(GlobalErrorContext)

    const [run, set_run] = useState(null)

    const runRef = useRef()
    runRef.current = run

    const syncedAtLeastOnceRef = useRef()
    syncedAtLeastOnceRef.current = false

    // init with empty arrays just so we can call it
    // TODO improve, we should init at null, and only set later
    const inventoryRef = useRef()
    inventoryRef.current = { jigs: [], codes: [] }

    const state = {
        // run: run,  // commenting bc we should not access run directly, instead use get_run_asyncf()

        /* we should not access this directly, but create a get_inventory_asyncf() function ? */
        get_inventory: get_inventory,

        get_syncedAtLeastOnce: get_syncedAtLeastOnce,

        inventory_sync: inventory_sync,
        get_run_asyncf: get_run_asyncf,  // only for other Contexts, avoid using in front-end !
        update_run: update_run,
        throwRunError: throwRunError,
    }

    function get_inventory() {
        return inventoryRef.current
    }

    function get_syncedAtLeastOnce() {
        return syncedAtLeastOnceRef.current
    }

    const [isLoading, set_isLoading] = useState(false)

    // // ref is needed for setTimeout to always have the latest value
    // // but beware: a ref changing value doesn’t trigger a re-render
    // const runRef = useRef(null)

    /**
     * call this function from runcraft once it has loaded
     */
    async function inventory_sync(...args) {
        const function_id = classname + "inventory_sync(): "
        const log = getLog(function_id)

        log("start with args=", args)
        let start_time = Date.now()

        const run = await get_run_asyncf()
        log("retrieved run instance in", (Date.now() - start_time), "ms")

        // custom inventory based on utxos only, should be faster than run.inventory.sync()
        const new_inventory = new RunInventory(run)
        log("new_inventory=", new_inventory, "in", (Date.now() - start_time), "ms\n utxos length=", new_inventory.utxos.length)

        log("syncing new_inventory...")
        await new_inventory.sync(...args)
        log("new_inventory sync over in", (Date.now() - start_time), "ms.",
            "new_inventory.length=", new_inventory.length)

        inventoryRef.current = new_inventory
        syncedAtLeastOnceRef.current = true
    }

    /**
     * call this function with await to make sure RUN has finished loading
     * BEWARE USING SETTIMEOUT MEANS WE NEED A REF, OTHERWISE THE VAR IS NEVER UPDATED
     *
     * maybe we should move get_run_asyncf() to UserContext ?
     * and just return the ref.current (using a function) in the runcontext state ?
     *
     * NOTE: tryduring_ms is imported from UserContext and is currently 10 MINUTES
     * (RUN_TIMEOUT_MS = 10 * 60 * 1000). The reject message below divides by 1000
     * and prints "seconds", which is technically correct (600s) but easy to misread
     * as a 10s timeout. The actual timeout is 10 minutes.
     */
    async function get_run_asyncf(retry_in = retryevery_ms) {
        const function_id = classname + "get_run_asyncf(): "
        const log = getLog(function_id)

        if (runRef.current) return runRef.current

        var trycounter = 0
        return new Promise(function(resolve, reject) {
            (async function waitFor() {
                log("waitFor, trycounter=", trycounter, "!!run=", !!run) // dont print run ! privkeys !
                trycounter += retry_in
                if (trycounter > tryduring_ms) {
                    return reject(
                        function_id + " timed out after " + (tryduring_ms / 1000) + " seconds"
                        + " (note: tryduring_ms = " + tryduring_ms + "ms = "
                        + (tryduring_ms / 60000).toFixed(1) + " minutes)"
                    )
                }

                if (runRef.current) return resolve(runRef.current)
                // DONT GENERATE A DEFAULT RUN, RATHER WAIT FOR RUNPARAMS TO BE PROVIDED in update_run()

                // setTimeout in Functional components: https://upmostly.com/tutorials/settimeout-in-react-components-using-hooks
                setTimeout(waitFor.bind(this), retry_in * 2) // *2 for exponential backoff

            }.bind(this))()
        }.bind(this))
    }


    /**
     * 	You can call throwRunError() when using run so that the error message includes "RUN ERROR"
        examples:
            new Run(..)
            await run.load(...)
            await run.sync(...)
        NOT when calling others like this.get_run_asyncf() => throwContextError for those
     */
    function throwRunError(error, premess = "") {
        globalErrorContext.throwContextError(error, "RUN ERROR: " + premess)
    }


    async function update_run(runparams, trustmode, tokenorigin = "") {
        const function_id = classname + "update_run(): "
        const log = getLog(function_id)
        let start_time = Date.now()

        // DO NOT LOG runparams BECAUSE IT CONTAINS PRIVKEYS

        if (!runparams) return // avoid a useless load of a random run instance

        if (isLoading) return  // check lock
        set_isLoading(true)   // take lock
        set_run(null)  // reset
        log("start update after", (Date.now() - start_time), "ms")

        if (runparams.api) log("runparams.api=", runparams.api)
        else log("runparams.api not set.")

        if (runparams.cache) {
            log("runparams.cache=", runparams.cache, "after", (Date.now() - start_time), "ms")
            log("banned_txhs.length=", banned_txhs.length)
            // Parallelize the cache.set calls — these are independent writes and
            // were previously sequential, adding ~10 round-trips to update_run.
            await Promise.all(banned_txhs.map(txh => runparams.cache.set("ban://" + txh, true)))
            log("finished runparams.cache.set()", "after", (Date.now() - start_time), "ms")
        }
        else log("runparams.cache not set.")

        if (!runparams.network) runparams.network = "main"

        if (runparams.blockchain) log("runparams.blockchain=", runparams.blockchain)
        else log("runparams.blockchain not set.")

        // DO NOT LOG runparams BECAUSE IT CONTAINS PRIVKEYS

        // TODO come back to this later to create a "broadcast only" mode
        // // if you want only whatsonchain activate this entire block
        // runparams.api="whatsonchain"
        // delete runparams.blockchain
        // // runparams.state is the State API implementation that Run will use to load jigs efficiently
        // // it defaults to StateServer (using run api)

        log("runparams.blockchain:", runparams.blockchain)
        if (runparams.blockchain) {
            const is_nofetchblockchain = isNoFetchBlockchain(runparams.blockchain)
            log("is_nofetchblockchain =", is_nofetchblockchain, "after", (Date.now() - start_time), "ms")

            if (is_nofetchblockchain) {
                log("detected NoFetchBlockchain: turning off Run's default LocalState")
                let run_cache = null

                if (runparams.cache && runparams.cache.cache) run_cache = runparams.cache.cache
                else if (runparams.cache) run_cache = runparams.cache

                log("run_cache=", typeof (run_cache), run_cache)
                let my_cache = new Run.plugins.LocalCache({ maxSizeMB: 200 })
                let nb_entries = 0
                for (let key in run_cache) {
                    my_cache.set(key, run_cache[key])
                    nb_entries += 1
                }
                log("populated the LocalState with", nb_entries, "entries")

                /* LocalState was created for the mockchain but we use it to only load from cache
                    (instead of from run's state server which is the default) */
                runparams.state = new Run.plugins.LocalState()
            }
            else {
                runparams.state = new CustomStateClient()
            }
            log("runparams.state=", runparams.state, "after", (Date.now() - start_time), "ms")
        }

        /* fix this in prod:
            ClientModeError: Cannot load c651779259d9f4d869aaf191c4d755545facb434c0a5d75d417bfc2f43320568
            Only cached transactions may be loaded in client mode 
            (apparently this happens because we fetch despite being in client=true)
        */

        /*
        // maybe even if runparams.client is true we should test the connexion
        // & auto turn it off if it fails ? 
        if (!runparams.client) {
            runparams.client = false  // default is false
            // test the connexion to our own run-db node
            const tokkenrStateClient = new TokkenrStateClient()
            const res = await tokkenrStateClient.ping()
            log("ping run-db:", res)
            if (res == true) {
                log("run-db ping success, turning client mode to true")
                runparams.client = true
            }
        }
        */

        // DO NOT LOG runparams BECAUSE IT CONTAINS PRIVKEYS
        log("runparams.client=", runparams.client)

        if (test_runnotresponding) {
            throw new Error(function_id + "test_runnotresponding")
        }

        // do not do this ! we still need to be able to get run !
        //if(this.state.revokedetected) return reject(function_id+" aborting because revokedetected")

        const run = new Run(runparams)
        if (runparams.cache) run.cache = runparams.cache
        // Parallelize the cache.set calls — same reasoning as the runparams.cache
        // block above. These are independent writes to distinct keys.
        await Promise.all(banned_txhs.map(txh => run.cache.set("ban://" + txh, true)))
        run.purse.jigFilter = true  // false to allow the purse to spend jigs, risky!
        run.backingLimit = 100 * 1000 * 1e8  // allow up to 100k bsv in backed jigs
        run.purse.feePerKb = 100  // override Run SDK default (50 sat/KB) -> 100 sat/KB
        run.activate()

        // DO NOT LOG runparams BECAUSE IT CONTAINS PRIVKEYS
        log("run.state=", run.state, "after", (Date.now() - start_time), "ms")

        if (trustmode) run.trust(trustmode)
        if (tokenorigin) {
            // run.trust(tokenorigin.split('_')[0])
            const myOraclesUtils = new OraclesUtils()
            await myOraclesUtils.load_trustRecursive(run, tokenorigin)
        }

        runRef.current = run
        set_run(run)
        set_isLoading(false)  // release lock

        // DO NOT LOG runparams BECAUSE IT CONTAINS PRIVKEYS
        log("run updated successfully. new owner address is", run.owner.address,
            "new purse address is", run.purse.address,
            "!!runparams=", !!runparams,
            "trust:", runparams.trust,
            "run.blockchain=", run.blockchain,
            "await run.purse.balance() =", await run.purse.balance(), "from", (await run.purse.utxos()).length, "utxos",
            "after", (Date.now() - start_time), "ms")

        return run
    }

    return (
        <RunContext.Provider value={state}>
            {props.children}
        </RunContext.Provider>
    )

}

export default RunContext
